import { ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ActivatedRoute } from '@angular/router';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScriptInjectorService } from '../../../core/services/script-injector.service';
import { environment } from '../../../../environments/environment';
import { BeaconChatService } from '../../../core/services/beacon-chat.service';
import * as fromAuth from '../../../auth/reducers';
var VideoCallPageComponent = /** @class */ (function () {
    function VideoCallPageComponent(_store, _elementRef, _route, _scriptInjector, _renderer, _beaconChatService) {
        this._store = _store;
        this._elementRef = _elementRef;
        this._route = _route;
        this._scriptInjector = _scriptInjector;
        this._renderer = _renderer;
        this._beaconChatService = _beaconChatService;
        this.originalPadding = null;
    }
    VideoCallPageComponent.prototype.ngOnInit = function () {
        this._beaconChatService.hideBeaconChat();
        // Override mat-sidenav-content padding
        var sidenavContent = document.querySelector('.mat-sidenav-content');
        if (sidenavContent) {
            this.originalPadding = sidenavContent.getAttribute('style');
            this._renderer.setStyle(sidenavContent, 'padding', '0px');
            // Add a class that we can target with !important in our CSS
            this._renderer.addClass(sidenavContent, 'video-call-active');
        }
        this.videoCallId$ = from(this._route.paramMap.pipe(map(function (params) {
            var id = params.get('id');
            // != null catches null or undefined
            if (id != null) {
                return String(id);
            }
            return null;
        })));
        this.videoCallEnabled$ = this._store.pipe(select(fromAuth.getVideoCallsEnabled));
        this.selectedLanguage$ = this._store.pipe(select(fromAuth.getLanguageCode));
        this.xSalveClinicToken$ = this._store.pipe(select(fromAuth.getClinicId));
        this.clinicVideoCallLoaded$ = from(this._scriptInjector
            .loadScript('salve-clinic-video-call', environment.videoCallComponentUrl)
            .then(function () { return true; })
            .catch(function () { return false; }));
    };
    VideoCallPageComponent.prototype.ngOnDestroy = function () {
        this._beaconChatService.showBeaconChat();
        // Restore original padding if it existed
        var sidenavContent = document.querySelector('.mat-sidenav-content');
        if (sidenavContent) {
            // Remove our special class
            this._renderer.removeClass(sidenavContent, 'video-call-active');
            if (this.originalPadding) {
                this._renderer.setAttribute(sidenavContent, 'style', this.originalPadding);
            }
            else {
                this._renderer.removeStyle(sidenavContent, 'padding');
            }
        }
    };
    return VideoCallPageComponent;
}());
export { VideoCallPageComponent };
